import { SvgIcon } from '@mui/material'

// Types
import { SvgIconProps } from '@mui/material'

const ReceiptIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={5}
				strokeMiterlimit={10}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M46.75 12.75V17.8925C46.75 21.25 44.625 23.375 41.2675 23.375H34V8.52125C34 6.1625 35.9338 4.25 38.2925 4.25C40.6088 4.27125 42.7338 5.20625 44.2638 6.73625C45.7938 8.2875 46.75 10.4125 46.75 12.75Z"
			/>

			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={5}
				strokeMiterlimit={10}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M4.25 14.875V44.625C4.25 46.3887 6.24745 47.3875 7.64995 46.325L11.2837 43.605C12.1337 42.9675 13.3238 43.0525 14.0888 43.8175L17.6162 47.3663C18.445 48.195 19.805 48.195 20.6338 47.3663L24.2038 43.7963C24.9475 43.0525 26.1375 42.9675 26.9663 43.605L30.6001 46.325C32.0026 47.3662 34 46.3675 34 44.625V8.5C34 6.1625 35.9125 4.25 38.25 4.25H14.875H12.75C6.375 4.25 4.25 8.05375 4.25 12.75V14.875Z"
			/>

			<g opacity={0.4}>
				<path fill="none" d="M12.75 19.125H25.5" stroke="currentColor" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" />
				<path fill="none" d="M14.3438 27.625H23.9062" stroke="currentColor" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" />
			</g>
		</SvgIcon>
	)
}

export default ReceiptIconAtom
